/**
 * Do not change this file manually! This file was generated with the "Dicebear Exporter"-Plugin for Figma.
 *
 * Plugin: https://www.figma.com/community/plugin/1005765655729342787
 */

import type { Prng } from '@dicebear/core';
import type { Options, ColorPickCollection } from '../types.js';
import { convertColor } from './convertColor.js';

type Props = {
  prng: Prng;
  options: Options;
};

export function getColors({ prng, options }: Props): ColorPickCollection {
  return {
    bgg: convertColor(prng.pick(options.bggColor ?? [], 'transparent')),
    goon: convertColor(prng.pick(options.goonColor ?? [], 'transparent')),
    wave2: convertColor(prng.pick(options.wave2Color ?? [], 'transparent')),
    wave3: convertColor(prng.pick(options.wave3Color ?? [], 'transparent')),
    wave1: convertColor(prng.pick(options.wave1Color ?? [], 'transparent')),
  };
}
